import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Recover automatically if a user hits a stale chunk after a deploy
// (common cause of ChunkLoadError). We only reload once.
const reloadOnChunkError = (err: any) => {
  const isChunkError = err && (err.name === 'ChunkLoadError' || /Loading chunk \d+ failed/.test(String(err.message || '')));
  const already = (window as any).__reloadedOnChunkError;
  if (isChunkError && !already) {
    (window as any).__reloadedOnChunkError = true;
    window.location.reload();
  }
};
window.addEventListener('error', (e) => reloadOnChunkError(e.error));
window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => reloadOnChunkError((e as any).reason));

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
